"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const get_1 = __importDefault(require("lodash/get"));
const TrError_1 = __importDefault(require("../../utils/TrError"));
exports.default = {
    /**
     * Save a collection to cache
     *
     * TODO: This method is basically used to save either the entire collection
     * (directly from the db using the socket prefix), or specific objects
     * returned in customCollection, which hopefully are the same type as the
     * calling collection. Sounds like a weird workflow
     *
     * @param collection The collection to save
     * @param socket The socket
     * @returns
     */
    saveCache: function (collection, socket) {
        return __awaiter(this, void 0, void 0, function* () {
            const socketPrefix = collection.socketPrefix;
            return new Promise((resolve, reject) => {
                socket.emit(`${socketPrefix}.saveCollectionCache`, (response) => {
                    if (!response.error) {
                        resolve(response);
                    }
                    else {
                        console.error(response.error);
                        reject(new TrError_1.default(`cannot save cache for ${socketPrefix}: ${response.error}`, 'TSC0001', `${socketPrefix}CacheCouldNotBeSavedBecauseServerError`));
                    }
                });
            });
        });
    },
    /**
     * Request the data to be loaded from cache. It does not modify the
     * collection
     *
     * @param collection The collection to load
     * @param socket The socket on which to call
     * @returns
     */
    loadCache: function (collection, socket) {
        return __awaiter(this, void 0, void 0, function* () {
            const socketPrefix = collection.socketPrefix;
            return new Promise((resolve, reject) => {
                socket.emit(`${socketPrefix}.loadCollectionCache`, (0, get_1.default)(collection.attributes, 'data.customCachePath'), (response) => {
                    if (!response.error) {
                        resolve(response);
                    }
                    else {
                        console.error(response.error);
                        reject(new TrError_1.default(`cannot load cache for ${socketPrefix}: ${response.error}`, 'TRC0001', `${socketPrefix}CacheCouldNotBeReadBecauseServerError`));
                    }
                });
            });
        });
    }
};
//# sourceMappingURL=CollectionCacheable.js.map